module.exports = {
  en: {
    title: 'Webhooks',
    subtitle: 'Sync data to third-party platforms through webhooks.',
    modal: {
      title: 'Select the event type',
      defaultDescription: 'One or more associated events, while the data will be sent with a default structure',
      customDescription: 'Individual event while the data will be sent with a custom structure',
      recommendedForIntegration: 'Recommended for integrations',
    },
    editor: {
      label: 'Editor',
      hint: 'In the editor you can define the structure in which the platform describes in its documentation and Videsk will inject the data based on the variables you enter with mustache, that is',
      hint2: 'The variables correspond to the data and metadata of the event.',
      name: {
        placeholder: 'Enter a name',
      },
      status: {
        hint: 'Enable or disable this webhooks without removing it'
      },
      methodUrl: {
        label: 'Method and URL',
        placeholder: 'Select a method',
      },
      conditional: {
        label: 'Send condition',
        hint: 'Evaluate a Handlebars expression before sending. The webhook only fires when the expression is truthy - useful to filter events without creating separate webhooks.',
        alert: 'Only conditional helpers are supported here. Using other helpers may cause the send to fail.',
      },
      headers: {
        label: 'Headers',
        add: 'Add header',
      },
      parameters: {
        label: 'URL Parameters',
        add: 'Add url parameter',
      },
      sslAlert: 'If you deactivate this box, we will not verify the validity of the SSL certificate when sending the data. (Disabling this is not recommended)',
      selectEvents: 'Select events',
      tabs: {
        dictionaryEvents: 'Dictionary events',
        dummy: 'Dummy data',
      },
      successSave: 'Webhook saved correctly',
    }
  },
  es: {
    title: 'Webhooks',
    subtitle: 'Sincroniza datos con tus plataformas mediante webhooks.',
    modal: {
      title: 'Selecciona el tipo de evento',
      tabs: {
        dictionaryEvents: 'Diccionario de eventos',
        dummy: 'Datos ficticios',
      },
      successSave: 'Webhook guardado correctamente',
      defaultDescription: 'Uno o más eventos asociados, mientras que los datos se enviarán con una estructura predeterminada',
      customDescription: 'Evento individual mientras que los datos se enviarán con una estructura personalizada',
      recommendedForIntegration: 'Recomendado para integraciones',
    },
    editor: {
      label: 'Editor',
      hint: 'En el editor puedes definir la estructura en la que la plataforma describe en su documentación y Videsk inyectará los datos en base a las variables que ingreses con mustache, es decir',
      hint2: 'Las variables corresponden a los datos y metadatos del evento.',
      name: {
        placeholder: 'Ingresa un nombre',
      },
      status: {
        hint: 'Habilita o deshabilita estos webhooks sin eliminarlos'
      },
      methodUrl: {
        label: 'Método y URL',
        placeholder: 'Selecciona un método',
      },
      conditional: {
        label: 'Condición de envío',
        hint: 'Evalúa una expresión Handlebars antes de enviar. El webhook solo se dispara si la expresión es verdadera - útil para filtrar eventos sin crear webhooks separados.',
        alert: 'Solo se admiten helpers condicionales en este campo. Usar otros helpers puede causar que el envío falle.',
      },
      headers: {
        label: 'Encabezados',
        add: 'Agregar encabezado',
      },
      parameters: {
        label: 'Parámetros de URL',
        add: 'Agregar parámetro de url',
      },
      sslAlert: 'Si desactivas esta casilla, no verificaremos la validez del certificado SSL al enviar los datos. (No se recomienda desactivar esto)',
      selectEvents: 'Selecciona eventos',
      tabs: {
        dictionaryEvents: 'Diccionario de eventos',
        dummy: 'Datos ficticios',
      },
      successSave: 'Webhook guardado correctamente',
    }
  },
  fr: {
    title: 'Webhooks',
    subtitle: 'Synchronisez les données avec des plateformes tierces via des webhooks.',
    modal: {
      title: 'Sélectionnez le type d\'événement',
      defaultDescription: 'Un ou plusieurs événements associés, tandis que les données seront envoyées avec une structure par défaut',
      customDescription: 'Événement individuel tandis que les données seront envoyées avec une structure personnalisée',
      recommendedForIntegration: 'Recommandé pour les intégrations',
    },
    editor: {
      label: 'Éditeur',
      hint: 'Dans l\'éditeur, vous pouvez définir la structure dans laquelle la plateforme est décrite dans sa documentation et Videsk injectera les données en fonction des variables que vous entrez avec moustache, c\'est-à-dire',
      hint2: 'Les variables correspondent aux données et métadonnées de l\'événement.',
      name: {
        placeholder: 'Entrez un nom',
      },
      status: {
        hint: 'Activez ou désactivez ce webhook sans le supprimer'
      },
      methodUrl: {
        label: 'Méthode et URL',
        placeholder: 'Sélectionnez une méthode',
      },
      conditional: {
        label: 'Condition d\'envoi',
        hint: 'Évalue une expression Handlebars avant l\'envoi. Le webhook ne se déclenche que si l\'expression est vraie - utile pour filtrer des événements sans créer de webhooks séparés.',
        alert: 'Seuls les helpers conditionnels sont pris en charge ici. L\'utilisation d\'autres helpers peut faire échouer l\'envoi.',
      },
      headers: {
        label: 'En-têtes',
        add: 'Ajouter un en-tête',
      },
      parameters: {
        label: 'Paramètres URL',
        add: 'Ajouter un paramètre URL',
      },
      sslAlert: 'Si vous désactivez cette case, nous ne vérifierons pas la validité du certificat SSL lors de l\'envoi des données. (Il est déconseillé de désactiver cela)',
      selectEvents: 'Sélectionner les événements',
      tabs: {
        dictionaryEvents: 'Événements du dictionnaire',
        dummy: 'Données fictives',
      },
      successSave: 'Webhook enregistré correctement',
    }
}

};
